import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { formatINR } from "@/lib/format";
import { ScrollArea } from "@/components/ui/scroll-area";

export default function IncomeRoadmap({ plan }) {
  return (
    <section
      className="mt-10 rounded-2xl border border-white/10 bg-[#111827]/70 p-6 sm:p-8"
      data-testid="income-roadmap-section"
    >
      <div className="flex items-start justify-between flex-wrap gap-2 mb-6">
        <div>
          <div className="text-[11px] uppercase tracking-[0.22em] text-[#F97316]">
            Age-wise Income
          </div>
          <h3 className="mt-2 font-heading text-2xl sm:text-3xl font-semibold tracking-tight">
            Your Future Income Roadmap
          </h3>
          <p className="mt-2 text-sm text-slate-400 max-w-xl">
            What you'll draw from your corpus every year after freedom — adjusted for inflation,
            forever.
          </p>
        </div>
        <div className="text-xs text-slate-500 num-font">
          From age {plan.inputs.freedomAge} • up to age 80
        </div>
      </div>

      <ScrollArea className="h-[420px] rounded-md border border-white/5">
        <Table data-testid="income-roadmap-table">
          <TableHeader className="sticky top-0 bg-[#0A0F1C] z-10">
            <TableRow className="border-white/10 hover:bg-transparent">
              <TableHead className="text-[11px] uppercase tracking-[0.18em] text-slate-400 w-1/4">
                Age
              </TableHead>
              <TableHead className="text-[11px] uppercase tracking-[0.18em] text-slate-400 text-right">
                Monthly Passive Income
              </TableHead>
              <TableHead className="text-[11px] uppercase tracking-[0.18em] text-slate-400 text-right">
                Yearly Passive Income
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {plan.incomeRoadmap.map((r, idx) => (
              <TableRow
                key={r.age}
                className={`border-white/5 hover:bg-white/5 transition-colors ${
                  idx === 0 ? "bg-[#F97316]/5" : ""
                }`}
                data-testid={`roadmap-row-${r.age}`}
              >
                <TableCell className="num-font text-slate-200 font-medium">
                  {r.age} {idx === 0 && <span className="text-[#F97316] text-xs ml-2">• freedom year</span>}
                </TableCell>
                <TableCell className="num-font text-right text-white">
                  {formatINR(r.monthlyIncome)}
                </TableCell>
                <TableCell className="num-font text-right text-slate-300">
                  {formatINR(r.yearlyIncome)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </ScrollArea>
    </section>
  );
}
